import { createAsyncThunk } from "@reduxjs/toolkit";
import { BaseConfigApi } from "../../Services/API/BaseConfigApi";
import { GET_TELEPHONE_COMPANIES } from "../../Constants/TelephoneCompanies";

/**
 * Method to get Telephone Companies
 */
export const GetTelephoneCompanies = createAsyncThunk(
  GET_TELEPHONE_COMPANIES,
  async (_payload, thunkAPI) => {
    try {
      const response = await BaseConfigApi.get(`/telephone-companies`);
      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
